import React, { useEffect, useState } from 'react';
import { get } from '../../../utils/getPropertyByPath';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { ReactComponent as ChevronArrowDown } from '../../../resources/icons/chevron-bold.svg';
import { ReactComponent as Shuffle } from '../../../resources/icons/shuffle.svg';
import getListing from '../../../utils/getListing';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
const SurpriseWizardPOI = _ref => {
  let {
    preselectedPOIS,
    algoliaIndexes,
    shuffleText,
    selectNames,
    queryParams,
    removedOldQueryString,
    isPreselectedValueExists,
    eventsAnalytics,
    params
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const [skipFirstLoad, setSkipFirstLoad] = useState(true);
  const getPreselectedPOIS = preselectedPOIS => preselectedPOIS.map(poi => ({
    url: get(poi, "url") || null,
    urlSlug: get(poi, "fallbackImage.jss.value.alt") || null,
    category: get(poi, "category.jss.fields.Title.value") || null,
    title: get(poi, "title.jss.value") || null,
    src: get(poi, "fallbackImage.jss.value.src") || null
  }));
  const [POIs, setPOIs] = useState(() => getPreselectedPOIS(preselectedPOIS));
  const [page, setPage] = useState(0);
  const gridArray = ["a", "b", "c", "d"];
  const requestToAlgolia = function () {
    let forceRequest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    const tag = selectNames.reduce((acc, name) => {
      if (queryParams[name]) {
        // @ts-ignore
        acc.push(`tags: ${queryParams[name]}`);
      }
      return acc;
    }, []);
    const itemFilters = {
      facetFilters: [tag, ["type: POI"]],
      hitsPerPage: 4,
      page
    };
    const itemFiltersForForceRequest = {
      facetFilters: [["type: POI"]],
      hitsPerPage: 4,
      page
    };
    const getPOIFromHits = hits => hits.map(hit => ({
      url: hit.url,
      urlSlug: hit.urlSlug,
      category: hit.category ? hit.category[0] : null,
      title: hit.title,
      src: hit.image
    }));
    const POIRequest = itemForFilters => {
      getListing(algoliaIndexes, itemForFilters, algoliaSettings).then(response => {
        setPOIs(getPOIFromHits(response.hits));
        setPage(prev => response.nbPages <= prev + 1 ? 0 : ++prev);
      }).catch(error => {
        console.log("error", error);
      });
    };
    if (tag.length) {
      POIRequest(itemFilters);
      return;
    }
    if (forceRequest) {
      POIRequest(itemFiltersForForceRequest);
      return;
    }
  };
  const handleShuffle = () => {
    requestToAlgolia(true);
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ShuffleButtonClickAnalytics'], params), shuffleText.toUpperCase());
  };
  useEffect(() => {
    if (skipFirstLoad && isPreselectedValueExists || removedOldQueryString) {
      requestToAlgolia();
    }
    setSkipFirstLoad(false);
  }, [queryParams]);
  const analyticsImageHandle = (e, text) => {
    e.stopPropagation();
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ImageClickAnalytics'], params), text);
  };
  const analyticsArrowHandle = (e, text) => {
    e.stopPropagation();
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ImageArrowClickAnalytics'], params), text);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, POIs.map((_ref2, index) => {
    let {
      url,
      urlSlug,
      category,
      title,
      src
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", {
      className: `POICardWrapper ${gridArray[index]}`,
      style: {
        backgroundImage: `url(${src})`
      },
      key: index,
      onClick: e => analyticsImageHandle(e, `${category} : ${urlSlug}`)
    }, /*#__PURE__*/React.createElement("a", {
      href: url,
      className: "POICardWrapperLink",
      onClick: e => analyticsArrowHandle(e, `${category} : ${urlSlug}`)
    }, category ? /*#__PURE__*/React.createElement("p", {
      className: "category"
    }, category.toUpperCase()) : null, /*#__PURE__*/React.createElement("div", {
      className: "content"
    }, /*#__PURE__*/React.createElement("p", {
      className: "title"
    }, title), /*#__PURE__*/React.createElement("span", {
      className: "circleLink"
    }, /*#__PURE__*/React.createElement(ChevronArrowDown, {
      className: "arrowIcon"
    })))));
  }), /*#__PURE__*/React.createElement("div", {
    className: "f"
  }, /*#__PURE__*/React.createElement("button", {
    className: "shuffle",
    onClick: handleShuffle
  }, /*#__PURE__*/React.createElement(Shuffle, {
    className: "shuffleIcon"
  }), shuffleText.toUpperCase())));
};
export { SurpriseWizardPOI };